import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Plugin } from "types/generated";

const PluginsTableDescriptionCell = ({
  item: plugin,
  ...cellProps
}: TableSimpleCellProps<Plugin>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={plugin.description} />
    </TableSimpleCell>
  );
};

export default PluginsTableDescriptionCell;
